import { PapiGallection } from '@wix/da-papi-types';

// convert flat folder array to a { folder, subfolders }[] array based on parentId attr
export const convertToFoldersWithSubfolders = (
  folders: PapiGallection[]
): PapiGallection[] => {
  return (
    folders
      // leave only top level folders
      .filter(isTopLevelFolder)
      // attach subfolders
      .map(folder => ({
        ...folder,
        subfolders:
          folder.hasSubfolders === false // little perf improvement - don't filter long lists if not needed
            ? []
            : folders.filter(
                potentialSubfolder =>
                  potentialSubfolder.parentId === folder.folderId
              ),
      }))
  );
};

export const isTopLevelFolder = folder => !folder.parentId;

export const filterTopLevelFolders = (folders: PapiGallection[]) =>
  folders.filter(isTopLevelFolder);
